import styled from "styled-components/macro"
import { mobile } from "../styles/responsive"

export const Container = styled.div``
export const Wrapper = styled.div`
  padding: 50px;
  display: flex;
  ${mobile({ padding: "10px", flexDirection: "column" })}
`
export const ImgContainer = styled.div`
  flex: 1;
`
export const Image = styled.img`
  width: 100%;
  height: 90vh;
  object-fit: cover;
  ${mobile({ height: "40vh" })}
`
export const InfoContainer = styled.div`
  flex: 1;
  padding: 20px 50px;
  ${mobile({ padding: "10px" })}
`
export const Title = styled.h1`
  font-weight: 300;
`
export const Description = styled.p`
  margin: 20px 0;
`
export const Price = styled.span`
  font-weight: 300;
  font-size: 35px;
`
export const AddContainer = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: space-between;
  margin-top: 20px;
  ${mobile({ width: "100%" })}
`
export const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
`
export const Amount = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
`
export const AmountButton = styled.div`
  &:hover {
    cursor: pointer;
  }
`
export const Button = styled.button`
  padding: 15px;
  border: 1px solid black;
  border-radius: 25px;
  background-color: white;
  cursor: pointer;

  &:hover {
    background-color: #4c87ef;
    color: white;
  }
`
